import React, { useContext, useMemo } from "react";

// packages
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import styles from "./broker.module.scss";
// context provides
import { ContractContext } from "../../../../providers/contract";
import { AuthConfig } from "../../../../setup/context/config/authConfig";
import {
  EContractType,
  IContractDetailsResponseData,
} from "../../../../setup/api/services/contract/models";

const BrokerPaymentDetails = ({
  isRefund,
  contract: passedContract,
}: {
  isRefund?: boolean;
  contract?: IContractDetailsResponseData;
}) => {
  const userId = AuthConfig?.getUserInfo()?.id;

  const { contract: contextContract, contractType } =
    useContext(ContractContext);
  function createRow(desc: string, price: number) {
    return { desc, price };
  }
  const { t } = useTranslation();

  const contract = useMemo(() => {
    return contractType === EContractType.COMPLEX_CONTRACT
      ? passedContract
      : contextContract;
  }, [contextContract, contractType, passedContract]);

  const rows = useMemo(() => {
    const brokerId = contract?.partiesProfiles?.BROKER?.[0]?.id;
    const buyerId = contract?.partiesProfiles?.PROVIDER?.[0]?.id;
    const itemPrice = contract?.itemPrice || 0;
    const brokerFee = contract?.brokerFee || 0;
    const fee = contract?.fee || 0;
    const total = itemPrice - brokerFee - fee;

    if (brokerId == +userId) {
      return [
        createRow(t("lbl_deposited_amount"), itemPrice),
        createRow(t("lbl_guaranter_fee"), brokerFee),
        createRow(t("lbl_contract_details_wafi_fee_title"), fee),
        createRow(
          isRefund ? t("lbl_depositor_amount") : t("lbl_depositor_receives"),
          total
        ),
      ];
    } else {
      if (buyerId == +userId) {
        return [createRow(t("lbl_deposited_amount"), total)];
      } else {
        return [createRow(t("lbl_deposited_amount"), itemPrice)];
      }
    }
  }, [
    contract?.brokerFee,
    contract?.fee,
    contract?.itemPrice,
    contract?.partiesProfiles?.BROKER,
    contract?.partiesProfiles?.PROVIDER,
    isRefund,
    t,
    userId,
  ]);

  return (
    <div className={styles.table_container}>
      <table className={styles.table_container__section}>
        <tbody>
          {rows.map((row, index) => (
            <>
              <tr key={row.desc}>
                <td
                  className={classNames(
                    rows?.length > 1 && styles?.pb12,
                    styles.table_cell,
                    "hint",
                    "g800",
                    index + 1 == rows.length
                  )}>
                  {row.desc}
                </td>
                <td
                  className={classNames(
                    styles.table_cell,
                    styles.price,
                    index + 1 == rows.length
                  )}
                  align="right">
                  <span className={"subtitle2"}>
                    {Number(row.price).toFixed(2)}{" "}
                    <span className={classNames("p2", "g700")}>
                      {" "}
                      {t("lbl_saudi_currency")}
                    </span>
                  </span>
                </td>
              </tr>
              {index !== rows.length - 1 && <div className={styles.divider} />}
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BrokerPaymentDetails;
